module.exports = __webpack_public_path__ + "static/media/mapping.e280df0e.PNG";